var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.svgClass,attrs:{"width":_vm.w,"height":_vm.h,"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }